import sileo from 'sileo';

const NegotiationMessageThread = new sileo.Model('scalema_new', 'negotiation-sidebar-message-thread');
const TPNegotiationSidePanel = new sileo.Model('scalema_new', 'tp-negotiation-side-panel');
const NegotiationMessage = new sileo.Model('scalema_new', 'negotiation-message');
const ClientQueryProposal = new sileo.Model('scalema_new', 'negotiation-client-query-proposal');
const ProposalPricingGroup = new sileo.Model('scalema_new', 'negotiation-proposal-pricing-group');
const Notifications = new sileo.Model('scalema_new', 'notification');

const actions = {
    fetchTPNegotiationSidePanelClients(context, filters) {
        return TPNegotiationSidePanel.objects.filter(filters);
    },

	fetchMessageThreads(context, filters) {
		return NegotiationMessageThread.objects.filter(filters);
	},

	getMessageThread(context, pk) {
		return NegotiationMessageThread.objects.get(pk);
	},

	getMessage(context, pk) {
		return NegotiationMessage.objects.get(pk);
	},

	fetchMessages(context, filters) {
		return NegotiationMessage.objects.filter(filters);
	},

	createMessage(context, data) {
		const form = new FormData();

		for (let field in data) {
			form.append(field, data[field]);
		}

		return NegotiationMessage.objects.create(form);
	},

	updateClientQueryProposal(context, data) {
        const form = new FormData();

        let pk = data.pk,
            dataKeys = Object.keys(data);

        dataKeys.forEach(key => {
            form.append(key, data[key]);
        });

        return ClientQueryProposal.objects.update({ 'pk': pk }, form);
    },

    getProposalPricingGroup(context, pk) {
        return ProposalPricingGroup.objects.get(pk);
    },

    createProposalPricingGroup(context, data) {
        const form = new FormData();
        const dataKeys = Object.keys(data);

        dataKeys.forEach(key => {
            form.append(key, data[key]);
        });

        return ProposalPricingGroup.objects.create(form);
    },

    updateProposalPricingGroup(context, data) {
        const form = new FormData();

        let pk = data.pk,
            dataKeys = Object.keys(data);

        dataKeys.forEach(key => {
            form.append(key, data[key]);
        });

        return ProposalPricingGroup.objects.update({ 'pk': pk }, form);
    },

    async getUnseenNotifications(context, filters) {
        return await Notifications.objects.filter(filters);
    },

    notificationMarkAsSeen(context, filters ) {
        return Notifications.objects.update(filters, { 'seen': 'True' });
    },
};

export default {
	namespaced: true,
	actions
};
